import el from "@cypherpotato/el";
import { Icon } from "./icon";

export function DropOverlay(handler) {
    
    window._dragHandler = handler;

    return el(".drop-overlay",
        el("div",
            Icon("drag-drop-line")
        )
    )
}